import { City } from "@interfaces/response/cities.interface";
import { orderBy } from "lodash";

export default function sortCities(cities: City[], order: "asc" | "desc" = "desc") {
  return orderBy(cities, [({ id }) => [1, 150, 149, 148].includes(id), "id"], [order]);
}